import React, { useState } from 'react'
import DashboardLayout from '../../../layoutcontainers/DashboardLayout'
import { AppBar, Toolbar, Box, Grid } from '@mui/material'
import MaterialButton from '../../../components/MaterialButton'
import MaterialTypography from '../../../components/MaterialTypography'
import ActiveRuns from './components/ActiveRuns'
import ClosedRuns from './components/ClosedRuns'
import { useNavigate } from 'react-router-dom'
import UnderDevelopmentPage from '../../UnderDevelopmentPage'

const projectList = [
  {
    value: 1,
    label: "All Rows"
  },
  {
    value: 2,
    label: "My Rows"
  },
  {
    value: 3,
    label: "Failed"
  },
  {
    value: 4,
    label: "Success"
  }
]

const TestRun = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("active");
  const [project, setProject] = useState("");
  const [projectOptions, setProjectOptions] = useState(projectList);
  const [input, setInput] = useState("");

  const handleProjectChange = (selectedProject) => {
    setProject(selectedProject);
  }

  const handleTestRunNavigate = () => {
    navigate('/test-run/create-test-run')
  }

  return (
    <DashboardLayout>
      {/* <Box sx={{ flexGrow: 1 }}>
        <AppBar position="sticky"
          sx={{
            backgroundColor: "#D7DEED",
            borderRadius: '8px'
          }}>
          <Toolbar>
            <MaterialTypography
              variant="h5"
              noWrap
              fontWeight="bold"
              color='dark'
              sx={{ flexGrow: 1, display: { xs: 'none', sm: 'block' } }}
            >
              Test Run
            </MaterialTypography>
            <MaterialButton variant="contained" color='dark' size="small" onClick={handleTestRunNavigate}>Create Test Run</MaterialButton>
          </Toolbar>
          <Box>
            <div style={{ width: "100%" }}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "30px",
                  padding: "1px 20px",
                }}
              >
                <div
                  onClick={() => setActiveTab("active")}
                  style={{
                    position: "relative",
                    cursor: "pointer",
                    color: activeTab === "active" ? "#1a73e8" : "#666",
                    fontWeight: activeTab === "active" ? "600" : "normal",
                    paddingBottom: "6px",
                    fontSize: "14px",
                  }}
                >
                  Active Runs
                  {activeTab === "active" && (
                    <div
                      style={{
                        position: "absolute",
                        bottom: 0,
                        left: 0,
                        height: "2px",
                        width: "100%",
                        backgroundColor: "#1a73e8",
                      }}
                    ></div>
                  )}
                </div>

                <div
                  onClick={() => setActiveTab("closed")}
                  style={{
                    position: "relative",
                    cursor: "pointer",
                    color: activeTab === "closed" ? "#1a73e8" : "#666",
                    fontWeight: activeTab === "closed" ? "600" : "normal",
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                    paddingBottom: "6px",
                    fontSize: "14px",
                  }}
                >
                  Closed Runs
                  {activeTab === "closed" && (
                    <div
                      style={{
                        position: "absolute",
                        bottom: 0,
                        left: 0,
                        height: "2px",
                        width: "100%",
                        backgroundColor: "#1a73e8",
                      }}
                    ></div>
                  )}
                </div>
              </div>
            </div>
          </Box>
        </AppBar>
      </Box>
      <Grid container spacing={2}>
        <Grid size={{ xs: 12 }}>
          <div>
            {activeTab === "active" ? <ActiveRuns project={project} handleProjectChange={handleProjectChange} projectOptions={projectOptions} input={input} /> : <ClosedRuns />}
          </div>
        </Grid>
      </Grid> */}
      <UnderDevelopmentPage />
    </DashboardLayout>
  )
}

export default TestRun
